/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
  loading: 'Loading...',
  boards: 'Boards',
  empty: 'Category is empty'
});
